module.exports = __webpack_public_path__ + "static/img/gs_04_m.b4fb60b5.jpg";